module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"list":"Student listing","manage":"Student statistics"},"zh-CN":{"list":"学生列表","manage":"学生统计"},"zh-TW":{"list":"學生列表","manage":"學生統計"},"it":{"list":"Elenco degli studenti","manage":"Statistiche degli studenti"},"id":{"list":"Daftar Siswa","manage":"Statistik Siswa"}}')
  delete Component.options._Ctor
}
